import { combineReducers } from 'redux';
import { uiStateReducer } from './ui';

export const rootReducer = combineReducers({
  ui: uiStateReducer,
});
